import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { Globals } from '../../globals';
import { DishServices } from '../dish/services';
import { HttpParams, HttpClient } from '@angular/common/http';
import { ProductsServices } from '../products/services';
import moment from 'moment';

interface ExtrasFooter {
  cafe_no: boolean;
  cafe_si: boolean;
  pan_vino_agua_no: boolean;
  pan_vino_agua_si: boolean;
  refresco_no: boolean;
  refresco_si: boolean;
}

interface Menu {
  UID: string;
  UID_RESTAURANT: string;
  caption_show: boolean;
  section_show: false,
  enumerate: boolean;
  extra: number;
  extras_footer: ExtrasFooter;
  footer: string;
  logo_show: boolean;
  price: number;
  price_takeaway: number;
  reference: string;
  sections: object;
  extras_section: object,
  separator: string;
  style: string;
  subtitle_ca: string;
  subtitle_de: string;
  subtitle_en: string;
  subtitle_es: string;
  subtitle_fr: string;
  subtitle_it: string;
  template: string;
  title_ca: string;
  title_de: string;
  title_en: string;
  title_es: string;
  title_fr: string;
  title_it: string;
  header_font_family: string;
  header_font_size: string;
  header_font_color: string;
  header_text_align: string;
  footer_font_family: string;
  footer_font_size: string;
  footer_font_color: string;
  footer_text_align: string;
  tpv_active: boolean;
  tk_active: boolean,
  pos_favourite: boolean;
  digital_app: boolean;
  template_name: string;
  image: string;
  tags: object;
  tk_pickup_day: string,
  footer_show: boolean,
  pos_background_color: string,
  pos_border_color: string,
  pos_color_name: string,
  order_share: number
}

@Injectable()
export class MenuServices {
  public firestore: any;
  menusCol: AngularFirestoreCollection<Menu>;
  menus: Observable<Menu[]>;
  menuDoc: AngularFirestoreDocument<Menu>;
  menu: any;
  menu_lang: string = 'es';

  //TMP
  public menu_dish_product_array_tmp: any = Array();
  public menu_dish_array_tmp: any = Array();
  public menu_section_array_complete_tmp: any;// Array section tmp
  public extras_footer: ExtrasFooter = {
    cafe_no: false,
    cafe_si: false,
    pan_vino_agua_no: false,
    pan_vino_agua_si: false,
    refresco_no: false,
    refresco_si: false,
  };

  public menu_tmp: Menu = {
    UID: '',
    UID_RESTAURANT: '',
    caption_show: false,
    section_show: false,
    enumerate: false,
    extra: 0,
    extras_footer: this.extras_footer,
    footer: '',
    logo_show: false,
    price: 0,
    price_takeaway: 0,
    reference: '',
    sections: {},
    extras_section: {},
    separator: '',
    style: '',
    subtitle_ca: '',
    subtitle_de: '',
    subtitle_en: '',
    subtitle_es: '',
    subtitle_fr: '',
    subtitle_it: '',
    template: '',
    title_ca: '',
    title_de: '',
    title_en: '',
    title_es: '',
    title_fr: '',
    title_it: '',
    header_font_family: '',
    header_font_size: '',
    header_font_color: '',
    header_text_align: '',
    footer_font_family: '',
    footer_font_size: '',
    footer_font_color: '',
    footer_text_align: '',
    tpv_active: true,
    tk_active: false,
    pos_favourite: false,
    digital_app: true,
    template_name: 'challenger',
    image: '',
    tags: [],
    tk_pickup_day: '',
    footer_show: true,
    pos_background_color: '',
    pos_border_color: '',
    pos_color_name: '',
    order_share: 0
  };

  public sections_array_tmp: any;
  public sections_extra_array_tmp: any;
  public custom_enumerate = false;
  public edit: any = false; // Marca si mostrar la parte de editar
  public edit_section: any = false; // Secciona a editar
  public edit_index: any = 0; // Indicie global de la seccion a editar
  public edit_dish_array: any;
  public edit_type: any;

  public pagesDishesProducts: any;
  public products_dishes_array_tmp: any;
  public products_dishes_array: any;
  public limit_pages: number;
  public page_active: number = 1;

  menu_cost: number = 0;
  sumands: number = 0;
  count_tmp: number = 0;

  public pagesCombos: any;
  public list_combos_array: any;
  public combos_array: any = [];
  public page_active_combos: number = 1;

  public pagesMenus: any;
  public list_menus_array: any;
  public menus_array: any = [];
  public page_active_menus: number = 1;

  public searchbar_text = '';

  public valueChanges: any;
  public url_share_xxss: string = "";

  constructor(public afs: AngularFirestore,
    public globals: Globals,
    public dishServices: DishServices,
    public http: HttpClient,
    public productServices: ProductsServices) {
    this.firestore = firebase.firestore();
  }



  getListMenus(UID_RESTAURANT) {
    this.menusCol = this.afs.collection('menus', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).orderBy('title_es', 'asc'));
    this.menus = this.menusCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Menu;
        data.UID = a.payload.doc.id;
        return data;


      });
    });



  }

  async getMenu(uid) {
    const menuRef = this.firestore.collection('menus').doc(uid);

    var _menu;

    await menuRef.get().then(doc => {
      _menu = doc.data();
      _menu.UID = doc.id;
    })

    return _menu

  }

  async getMenus(UID_RESTAURANT) {
    const menusRef = this.firestore.collection('menus');

    var menus = [];

    await menusRef.where('UID_RESTAURANT', '==', UID_RESTAURANT).get()
      .then(snapshot => {
        snapshot.forEach(doc => {

          var menu = doc.data();
          menu.UID = doc.id;

          menus.push(menu);
        })
      });

    return menus
  }

  delete(uid) {
    this.afs.doc('menus/' + uid).delete();
  }


  async checkIfAnyDishNoFoodcost(menu_uid) {
    var dish_no_foodcost: boolean = false

    var menu = await this.getMenu(menu_uid);
    //no plats
    if (menu.sections.length == 0) {
      dish_no_foodcost = true;
    }

    for (let section of this.globals.objectToArray(menu.sections)) {
      for (let _dish of this.globals.objectToArray(section.dish)) {
        var dish;
        if (_dish.type == 'product') {
          dish = await this.productServices.getProduct(_dish.uid);
        } else {
          dish = await this.dishServices.getDish(_dish.uid);
        }
        //plat no foodcost
        if (dish.foodcost) {
          if (Object.keys(dish.foodcost).length == 0) {
            dish_no_foodcost = true;
          }
        }
      }
    }

    return dish_no_foodcost;
  }

  //FILTER
  public filteredProductsDishes: any;
  public filteredProductsDishesActive: boolean = false;
  searchProductsDishesNode(value) {
    if (value.target.value == '' || value.target.value == undefined) {
      this.filteredProductsDishesActive = false;
    } else {

      if (value.target.value.length >= 3) {

        let limit_dishes = this.globals.checkLimitsByLicense('dishes', 'max_dishes');
        let limit_products = this.globals.checkLimitsByLicense('stock', 'ings_prods');

        //Miramos si la licencia tiene límite de stock o de platos
        if (limit_products > 0 && limit_dishes > 0) {
          //si lo tiene lo mandamos a buscar dentro del listado reducido
          const params = new HttpParams()
            .set('uid', this.globals.restaurant_uid)
            .set('filter_string', value.target.value.toLowerCase())
            .set('limit_dishes', limit_dishes)
            .set('limit_products', limit_products);
          this.http.post(this.globals.analytics_path + 'filter/limited_dishes_products', params, {})
            .subscribe(async res => {
              this.filteredProductsDishes = res;
              this.filteredProductsDishesActive = true;
            });
        } else {
          //Si no tiene límite filtramos dentro del todos los platos y productos
          const params = new HttpParams()
            .set('uid', this.globals.restaurant_uid)
            .set('filter_string', value.target.value.toLowerCase());
          this.http.post(this.globals.analytics_path + 'filter/dishes_products', params, {})
            .subscribe(async res => {
              this.filteredProductsDishes = res;
              this.filteredProductsDishesActive = true;
            });

        }

      } else {
        this.filteredProductsDishesActive = false;
      }
    }

  }

  first_element: any;
  get_dishes_products_done: boolean = false;


  //PAGINATE
  async getPagesDishesProducts(elements_per_page) {
    this.get_dishes_products_done = false;
    this.filteredProductsDishesActive = false;
    this.limit_pages = elements_per_page;

    let limit_dishes = this.globals.checkLimitsByLicense('dishes', 'max_dishes');
    let limit_products = this.globals.checkLimitsByLicense('stock', 'ings_prods');

    //Miramos si la licencia tiene límite de stock o de platos
    if (limit_products > 0 && limit_dishes > 0) {
      //si lo tiene lo mandamos a recuperar X cantidad de productos y  X cantidad de platos
      const params = new HttpParams()
        .set('uid', this.globals.restaurant_uid)
        .set('elements_per_page', elements_per_page)
        .set('limit_dishes', limit_dishes)
        .set('limit_products', limit_products);

      await this.http.post(this.globals.analytics_path + 'paginate/limited_dishes_products', params, {})
        .subscribe(async res => {
          this.pagesDishesProducts = Array(res['pages']).fill(0).map((x, i) => i + 1); //Create an array for the loop of pages that start in 1
          this.products_dishes_array_tmp = res['list'];
          if (this.pagesDishesProducts != 0) {
            this.getListDishesProductsMinMax();
          } else {
            this.get_dishes_products_done = true;
          }
        });

    } else {
      //Si no tiene límite le mandamos a recuperar con el paginador
      const params = new HttpParams()
        .set('uid', this.globals.restaurant_uid)
        .set('elements_per_page', elements_per_page);
      await this.http.post(this.globals.analytics_path + 'paginate/dishes_products', params, {})
        .subscribe(async res => {
          this.pagesDishesProducts = Array(res['pages']).fill(0).map((x, i) => i + 1); //Create an array for the loop of pages that start in 1
          this.products_dishes_array_tmp = res['list'];
          if (this.pagesDishesProducts != 0) {
            this.getListDishesProductsMinMax();
          } else {
            this.get_dishes_products_done = true;
          }
        });
    }
  }
  getListDishesProductsMinMax() {
    this.get_dishes_products_done = true;

    //Ordenamos el array
    this.products_dishes_array_tmp.sort((a, b) => this.globals.nameLangSelectDish(a).localeCompare(this.globals.nameLangSelectDish(b)));

    //Search for first element to start
    this.first_element = (this.page_active - 1) * this.limit_pages;
    //We slice the array with the first element, and the first element plus the limit to get the last index
    if (this.limit_pages > 0) {
      this.products_dishes_array = this.products_dishes_array_tmp.slice(this.first_element, this.first_element + this.limit_pages);
    } else {
      this.products_dishes_array = this.products_dishes_array_tmp;
    }
  }

  //Combos
  public filteredCombos: any;
  public filteredCombosActive: boolean = false;
  searchCombosNode(value) {
    if (value.target.value == '' || value.target.value == undefined) {
      this.filteredCombosActive = false;
    } else {
      if (value.target.value.length >= 3) {
        const params = new HttpParams()
          .set('uid', this.globals.restaurant_uid)
          .set('filter_string', value.target.value.toLowerCase());
        this.http.post(this.globals.analytics_path + 'combos/filter_combos', params, {})
          .subscribe(async res => {
            this.filteredCombos = res;
            if (this.filteredCombos.length != 0) {
              this.getFilterCombos();
            } else {
              this.filteredCombosActive = true;
            }
          });
      } else {
        this.filteredCombosActive = false;
      }
    }
  }

  getFilterCombos() {
    //Ordenamos el array
    this.filteredCombos.sort((a, b) => this.globals.nameLangSelectMenu(a).localeCompare(this.globals.nameLangSelectMenu(b)));

    //Recorremos el array filtrada
    this.filteredCombos.forEach(combo => {
      //Buscamos el combo en el array no filtrada de combos para ver los que no estan activos por version
      var index = this.list_combos_array.findIndex(x => x.UID == combo.UID);
      if (index >= 0) {
        combo._active = this.list_combos_array[index]._active;
      } else {
        combo._active = false;
      }
    });
    this.filteredCombosActive = true;
  }

  get_combos_done: boolean = false;
  first_combos_name: any;

  async getPagesCombos(elements_per_page) {
    this.get_combos_done = false;
    this.filteredCombosActive = false;
    this.limit_pages = elements_per_page;

    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('elements_per_page', elements_per_page);
    await this.http.post(this.globals.analytics_path + 'combos/paginate_combos', params, {})
      .subscribe(async res => {
        this.pagesCombos = Array(res['pages']).fill(0).map((x, i) => i + 1); //Create an array for the loop of pages that start in 1
        this.list_combos_array = res['list_combos'];
        this.first_combos_name = res['first_combos_name'];
        if (this.pagesCombos != 0) { //Si hay paginas
          this.getListCombosNode();
        } else { //Si no hay paginas
          this.get_combos_done = true;
        }
      });
  }

  getListCombosNode() {
    this.get_combos_done = true;
    this.list_combos_array.sort((a, b) => this.globals.nameLangSelectMenu(a).localeCompare(this.globals.nameLangSelectMenu(b)));

    //For para poner en activo los combos que puede ver el free.
    this.list_combos_array.forEach((value, index) => {
      value._active = true;
      if (index >= this.globals.checkLimitsByLicense('daily_menu', 'limit_combo') && this.globals.checkLimitsByLicense('daily_menu', 'limit_combo') != -1) {
        value._active = false;
      }
    });

    if (this.limit_pages > 0) {
      //Search for first element to start
      this.first_combos_name = (this.page_active_combos - 1) * this.limit_pages;
      //We slice the array with the first element, and the first element plus the limit to get the last index
      this.combos_array = this.list_combos_array.slice(this.first_combos_name, this.first_combos_name + this.limit_pages);
    } else {
      this.combos_array = this.list_combos_array;
    }
  }

  //Menus
  public filteredMenus: any;
  public filteredMenusActive: boolean = false;
  searchMenusNode(value) {
    if (value.target.value == '' || value.target.value == undefined) {
      this.filteredMenusActive = false;
    } else {
      if (value.target.value.length >= 3) {
        const params = new HttpParams()
          .set('uid', this.globals.restaurant_uid)
          .set('filter_string', value.target.value.toLowerCase());
        this.http.post(this.globals.analytics_path + 'menus/filter_menus', params, {})
          .subscribe(async res => {
            this.filteredMenus = res;
            this.filteredMenusActive = true;
            if (this.filteredMenus.length != 0) {
              this.getFilterMenus();
            } else {
              this.filteredMenusActive = true;
            }
          });
      } else {
        this.filteredMenusActive = false;
      }
    }
  }

  getFilterMenus() {
    //Ordenamos el array
    this.filteredMenus.sort((a, b) => this.globals.nameLangSelectMenu(a).localeCompare(this.globals.nameLangSelectMenu(b)));

    //Recorremos el array filtrada
    this.filteredMenus.forEach(menu => {
      //Buscamos el menu en el array no filtrada de menus para ver los que no estan activos por version
      var index = this.list_menus_array.findIndex(x => x.UID == menu.UID);
      if (index >= 0) {
        menu._active = this.list_menus_array[index]._active;
      } else {
        menu._active = false;
      }
    });
    this.filteredMenusActive = true;
  }

  get_menus_done: boolean = false;
  first_menus_name: any;

  async getPagesMenus(elements_per_page) {
    this.get_menus_done = false;
    this.filteredMenusActive = false;
    this.limit_pages = elements_per_page;

    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('elements_per_page', elements_per_page);
    await this.http.post(this.globals.analytics_path + 'menus/paginate_menus', params, {})
      .subscribe(async res => {
        this.pagesMenus = Array(res['pages']).fill(0).map((x, i) => i + 1); //Create an array for the loop of pages that start in 1
        this.list_menus_array = res['list_menus'];
        this.first_menus_name = res['first_menus_name'];
        if (this.pagesMenus != 0) { //Si hay paginas
          this.getListMenusNode();
        } else { //Si no hay paginas
          this.get_menus_done = true;
        }
      });
  }

  getListMenusNode() {
    this.get_menus_done = true;
    this.list_menus_array.sort((a, b) => this.globals.nameLangSelectMenu(a).localeCompare(this.globals.nameLangSelectMenu(b)));

    //For para poner en activo los combos que puede ver el free.
    this.list_menus_array.forEach((value, index) => {
      value._active = true;
      if (index >= this.globals.checkLimitsByLicense('daily_menu', 'limit') && this.globals.checkLimitsByLicense('daily_menu', 'limit') != -1) {
        value._active = false;
      }
    });

    if (this.limit_pages == 0) {
      this.menus_array = this.list_menus_array;
    } else {
      //Search for first element to start
      this.first_menus_name = (this.page_active_menus - 1) * this.limit_pages;
      //We slice the array with the first element, and the first element plus the limit to get the last index
      this.menus_array = this.list_menus_array.slice(this.first_menus_name, this.first_menus_name + this.limit_pages);
    }
  }

  //Analitics
  public mostMenuSale: any = '';
  async analyticsGetMostSoldMenu() {
    //enviar post la peticion y devuelve el menu mas vendido
    this.http.post(this.globals.api_path + 'analytics/menu/most_sold_menu?uid=' + this.globals.restaurant_uid
      , {}, {})
      .subscribe(res => {
        this.mostMenuSale = res['sales_menu'];
      });
  }

  public highestCommercialMarginMenu: any = '';
  async analyticsGetHighestCommercialMarginMenu() {
    //enviar post la peticion y devuelve el menu con mas margen comercial
    this.http.post(this.globals.api_path + 'analytics/menu/highest_commercial_margin_menu?uid=' + this.globals.restaurant_uid
      , {}, {})
      .subscribe(res => {
        this.highestCommercialMarginMenu = res['highest_commercial_margin_menu'];
      });
  }

  //
  public total_menu_sold: any = 0;
  async analyticsGetMenusSoldToday() {
    var date = moment().format("YYYY-MM-DD");
    //enviar post la peticion y devuelve el plato mas vendido del mes
    this.http.post(this.globals.api_path + 'analytics/menu/menus_sold_today?uid=' + this.globals.restaurant_uid
      + '&date=' + date
      , {}, {})
      .subscribe(res => {
        this.total_menu_sold = res['menus_sold_today'];
      });
  }

  menuTitleByLang(menu) {
    switch (this.globals.restaurant.lang) {
      case 'es': {
        return menu.title_es
      }
      case 'ca': {
        return menu.title_ca
      }
      case 'en': {
        return menu.title_en
      }
      case 'de': {
        return menu.title_de
      }
      case 'fr': {
        return menu.title_fr
      }
      case 'it': {
        return menu.title_it
      }
      default: {
        return menu.title_en
      }
    }
  }

  filterCombo(value) {
    var _return = [];
    this.filteredCombosActive = false;

    if (value != undefined && value.length > 0) {
      this.combos_array.forEach(combo => {

        if (combo.title_es != undefined && combo.title_es.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(combo);
        } else if (combo.title_en != undefined && combo.title_en.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(combo);
        } else if (combo.title_ca != undefined && combo.title_ca.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(combo);
        } else if (combo.title_de != undefined && combo.title_de.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(combo);
        } else if (combo.title_fr != undefined && combo.title_fr.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(combo);
        } else if (combo.title_it != undefined && combo.title_it.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(combo);
        } else if (combo.subtitle_es != undefined && combo.subtitle_es.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(combo);
        } else if (combo.subtitle_en != undefined && combo.subtitle_en.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(combo);
        } else if (combo.subtitle_ca != undefined && combo.subtitle_ca.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(combo);
        } else if (combo.subtitle_de != undefined && combo.subtitle_de.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(combo);
        } else if (combo.subtitle_fr != undefined && combo.subtitle_fr.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(combo);
        } else if (combo.subtitle_it != undefined && combo.subtitle_it.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(combo);
        } else if (combo.tags_static != undefined && combo.tags_static.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(combo);
        } else if (combo.menu_cost != undefined && combo.menu_cost.toFixed(2).toString().replace(/\./g, ',').includes(value.replace(/\./g, ','))) {
          _return.push(combo);
        } else if (combo.price != undefined && combo.price.toFixed(2).toString().replace(/\./g, ',').includes(value.replace(/\./g, ','))) {
          _return.push(combo);
        } else if (combo.reference != undefined && combo.reference == value) {
          _return.push(combo);
        }
      });

      this.filteredCombosActive = true;
      this.filteredCombos = _return;
      this.filteredCombos = [...this.filteredCombos];
    }
  }

  filterMenu(value) {
    var _return = [];
    this.filteredMenusActive = false;

    if (value != undefined && value.length > 0) {
      this.menus_array.forEach(menu => {

        if (menu.title_es != undefined && menu.title_es.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(menu);
        } else if (menu.title_en != undefined && menu.title_en.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(menu);
        } else if (menu.title_ca != undefined && menu.title_ca.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(menu);
        } else if (menu.title_de != undefined && menu.title_de.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(menu);
        } else if (menu.title_fr != undefined && menu.title_fr.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(menu);
        } else if (menu.title_it != undefined && menu.title_it.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(menu);
        } else if (menu.subtitle_es != undefined && menu.subtitle_es.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(menu);
        } else if (menu.subtitle_en != undefined && menu.subtitle_en.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(menu);
        } else if (menu.subtitle_ca != undefined && menu.subtitle_ca.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(menu);
        } else if (menu.subtitle_de != undefined && menu.subtitle_de.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(menu);
        } else if (menu.subtitle_fr != undefined && menu.subtitle_fr.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(menu);
        } else if (menu.subtitle_it != undefined && menu.subtitle_it.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(menu);
        } else if (menu.tags_static != undefined && menu.tags_static.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(menu);
        } else if (menu.menu_cost != undefined && menu.menu_cost.toFixed(2).toString().replace(/\./g, ',').includes(value.replace(/\./g, ','))) {
          _return.push(menu);
        } else if (menu.price != undefined && menu.price.toFixed(2).toString().replace(/\./g, ',').includes(value.replace(/\./g, ','))) {
          _return.push(menu);
        } else if (menu.reference != undefined && menu.reference == value) {
          _return.push(menu);
        }
      });

      this.filteredMenusActive = true;
      this.filteredMenus = _return;
      this.filteredMenus = [...this.filteredMenus];
    }
  }

  /**
   * Completa los campos de idioma vacíos en una sección con el valor del idioma por defecto.
   * @param section Objeto de sección con campos name, name_ca, name_en, name_de, name_fr, name_it
   * @param defaultLanguage Idioma por defecto del restaurante ('es', 'ca', 'en', 'de', 'fr', 'it')
   * @returns La sección con todos los campos de idioma completados
   */
  ensureSectionLanguageFields(section: any, defaultLanguage: string): any {
    if (!section) return section;

    // Mapeo de idiomas a campos
    const langFieldMap = {
      'es': 'name',
      'ca': 'name_ca',
      'en': 'name_en',
      'de': 'name_de',
      'fr': 'name_fr',
      'it': 'name_it'
    };

    // Obtener el campo correspondiente al idioma por defecto
    const defaultField = langFieldMap[defaultLanguage] || 'name';
    const defaultValue = section[defaultField] || '';

    // Si el valor por defecto está vacío, no hay nada que propagar
    if (!defaultValue || defaultValue.trim() === '') {
      return section;
    }

    // Completar todos los campos de idioma que estén vacíos
    const langFields = ['name', 'name_ca', 'name_en', 'name_de', 'name_fr', 'name_it'];
    langFields.forEach(field => {
      if (!section[field] || section[field].trim() === '') {
        section[field] = defaultValue;
      }
    });

    return section;
  }
}



// WEBPACK FOOTER //
// ./src/pages/menu/services.ts